// AI-CONTEXT: See docs/features/updates-log.md
// De categorieën waarop de Updates-pagina filtert: de vier abonnementsmodules
// plus 'algemeen' voor wijzigingen die iedereen raken (inloggen, dashboard,
// instellingen, rapportages).

import MODULES from '../subscriptionHelpers/moduleDefinitions'

/**
 * @typedef {object} UpdateModule
 * @property {string} slug - Code zoals hij in updates.json staat
 * @property {string} label - Wat de gebruiker leest
 */

// Wijzigingen die niet aan één module hangen. Iedereen ziet ze, ongeacht het
// abonnement — zonder deze categorie zou elke algemene update alle vier de
// modules moeten aankruisen, of nergens terechtkunnen.
const ALWAYS_VISIBLE_MODULE = 'algemeen'

// De labels van de betaalde modules komen uit moduleDefinitions.js, zodat de
// Updates-pagina nooit een naam toont die elders in de app anders heet.
// updateModules.test.js pint die pariteit vast.
/** @type {Object<string, UpdateModule>} */
const UPDATE_MODULES = {
    [ALWAYS_VISIBLE_MODULE]: { slug: ALWAYS_VISIBLE_MODULE, label: 'Algemeen' },
    impactMeten: { slug: 'impactMeten', label: MODULES.impactMeten.name },
    personas: { slug: 'personas', label: MODULES.personas.name },
    housevisits: { slug: 'housevisits', label: MODULES.housevisits.name },
    portfolio: { slug: 'portfolio', label: MODULES.portfolio.name },
}

/** @type {Array<string>} */
const UPDATE_MODULE_SLUGS = Object.keys(UPDATE_MODULES)

export { ALWAYS_VISIBLE_MODULE, UPDATE_MODULES, UPDATE_MODULE_SLUGS }
